<script setup>
import { ref, computed } from 'vue'
import { useSnackbarStore } from '@/store/snackbar'
import BaseSnackbar from '@/components/foundations/BaseSnackbar.vue'

const DESKTOP_MAX_VISIBLE = 3
const MOBILE_MAX_VISIBLE = 1
const MOBILE_MQ = window.matchMedia('(max-width: 767px)')

const store = useSnackbarStore()

const isMobile = ref(MOBILE_MQ.matches)
MOBILE_MQ.addEventListener('change', e => { isMobile.value = e.matches })

const visibleItems = computed(() =>
  store.items.slice(0, isMobile.value ? MOBILE_MAX_VISIBLE : DESKTOP_MAX_VISIBLE)
)
</script>

<template>
  <Teleport to="body">
    <div
      class="
        fixed z-[9999] flex flex-col gap-[8px] pointer-events-none items-center
        bottom-[16px] right-[16px] left-[16px]
        md:bottom-[24px] md:right-[24px] md:left-auto md:items-end
      "
    >
      <TransitionGroup name="snackbar" tag="div" class="flex flex-col gap-[8px] items-center w-full md:items-end md:w-auto">
        <BaseSnackbar
          v-for="item in visibleItems"
          :key="item.id"
          class="pointer-events-auto"
          :snackbar="item"
          @close="store.remove(item.id)"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.snackbar-enter-active {
  transition: opacity 0.25s ease, transform 0.3s ease;
}
.snackbar-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.snackbar-enter-from {
  opacity: 0;
  transform: translateY(16px);
}
.snackbar-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.snackbar-move {
  transition: transform 0.3s ease;
}
</style>
